import { toast } from 'react-toastify';
import store from '../redux/store';
import { logOut } from '../redux/auth/actions';

const INACTIVITY_TIMEOUT = 15 * 60 * 1000;
const COUNTDOWN_INTERVAL = 1000;

let inactivityTimer;
let countdownInterval;
let remainingTime = INACTIVITY_TIMEOUT;

/**
 * Resets the inactivity timer and sets up a new timeout to log out the user after inactivity.
 */
const resetTimer = () => {
  const stayLoggedIn = localStorage.getItem('stayLoggedIn') === 'true';
  if (stayLoggedIn) {
    return;
  }
  
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
  
  remainingTime = INACTIVITY_TIMEOUT;
  
  const state = store.getState();
  if (state.auth.isAuthenticated) {
    countdownInterval = setInterval(() => {
      remainingTime -= COUNTDOWN_INTERVAL;
      
      if (remainingTime <= 0) {
        clearInterval(countdownInterval);
      }
    }, COUNTDOWN_INTERVAL);
    
    inactivityTimer = setTimeout(() => {
      store.dispatch(logOut());
      
      toast.info('You have been logged out due to inactivity.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      
      if (countdownInterval) {
        clearInterval(countdownInterval);
      }
    }, INACTIVITY_TIMEOUT);
  }
};

/**
 * Sets up the inactivity timer by adding event listeners and initializing the timer, unless stay logged in is enabled.
 */
export const setupInactivityTimer = () => {
  const stayLoggedIn = localStorage.getItem('stayLoggedIn') === 'true';
  if (stayLoggedIn) {
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
      inactivityTimer = null;
    }
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    return;
  }
  
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
  ];
  
  activityEvents.forEach(event => {
    window.addEventListener(event, resetTimer);
  });
  
  resetTimer();
};

/**
 * Clears the inactivity timer and removes all event listeners to prevent memory leaks.
 */
export const clearInactivityTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
  
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
  ];
  
  activityEvents.forEach(event => {
    window.removeEventListener(event, resetTimer);
  });
};